import { createElement, useState } from '@wordpress/element';
import { GeneralTab, OtherSettingsTab, PincodeList, AddPincode } from './Tabs';
import { ToastContainer, useToast } from './ui';

const TABS = [
    { id: 'general', label: 'General Settings' },
    { id: 'text',    label: 'Text & Labels'    },
    { id: 'list',    label: 'Pincode List'     },
    { id: 'add',     label: 'Add Pincode'      },
];

const App = () => {
    const [activeTab, setActiveTab] = useState('general');
    const [editId, setEditId]       = useState(null);
    const { toasts, toast, removeToast } = useToast();

    const handleEdit = (id) => { setEditId(id); setActiveTab('add'); };
    const handleEditDone = () => { setEditId(null); setActiveTab('list'); };
    const handleTabClick = (id) => { if (id !== 'add') setEditId(null); setActiveTab(id); };

    return (
        <div id="cpiw-admin-root">
            <ToastContainer toasts={toasts} onRemove={removeToast} />

            <div className="cpiw-page">

                {/* Page Header */}
                <div className="cpiw-page-header">
                    <div className="cpiw-page-header__left">
                        <div>
                            <h1 className="cpiw-page-header__title">Check Pincode For WooCommerce</h1>
                            <p className="cpiw-page-header__sub">WooCommerce delivery availability by postal code</p>
                        </div>
                    </div>
                    <div className="cpiw-page-header__actions">
                        <a href="https://www.plugin999.com/plugin/check-pincode-for-woocommerce/" target="_blank" rel="noreferrer" className="cpiw-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#ffc83d"><path d="M3 7l4 4 5-7 5 7 4-4-2 13H5L3 7z"/></svg> Pro Version
                        </a>
                        <a href="https://www.plugin999.com/support/" target="_blank" rel="noreferrer" className="cpiw-btn-secondary">
                            &#128172; Support
                        </a>
                        <a href="https://wordpress.org/support/plugin/check-pincode-for-woocommerce/reviews/" target="_blank" rel="noreferrer" className="cpiw-btn">
                            &#11088; Rate Plugin
                        </a>
                    </div>
                </div>

                {/* Shortcode pill */}
                <div className="cpiw-shortcode-pill">
                    <span className="cpiw-shortcode-pill__label">Shortcode</span>
                    <code className="cpiw-shortcode-pill__code">[cpiw-pincode-checker]</code>
                    <span className="cpiw-shortcode-pill__desc">Add this shortcode anywhere to display the pincode checker widget.</span>
                </div>

                {/* Tab Nav */}
                <div className="cpiw-tabs">
                    <div className="cpiw-tab-nav">
                        {TABS.map((tab) => (
                            <button
                                key={tab.id}
                                className={`cpiw-tab-btn${activeTab === tab.id ? ' cpiw-tab-btn--active' : ''}`}
                                onClick={() => handleTabClick(tab.id)}
                            >
                                {tab.id === 'add' && editId ? `✎ Edit #${editId}` : tab.label}
                            </button>
                        ))}
                    </div>

                    <div className="cpiw-tab-content">
                        {activeTab === 'general' && <GeneralTab toast={toast} />}
                        {activeTab === 'text'    && <OtherSettingsTab toast={toast} />}
                        {activeTab === 'list'    && <PincodeList onEdit={handleEdit} toast={toast} />}
                        {activeTab === 'add'     && <AddPincode editId={editId} onEditDone={handleEditDone} toast={toast} />}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default App;
